<template>
  <div id="container-customer-form">
    <div>
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="insert-data-container">
            <div class="input-area">
              <div class="vx-card p-6 input-group">

                <vs-row vs-type="flex" vs-w="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                    vs-w="12"
                  >

                    <div class="title-area w-full">
                      <span class="aisea-text-24-400-black">顧客情報</span>
                      <div
                        v-if="isViewMode"
                        class="aisea-text-14-400-blue back-button"
                        @click="backToMaster"
                      >
                        <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
                        <span>一覧へ戻る</span>
                      </div>
                    </div>

                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                    vs-w="12"
                  >
                    <div class="string-input">
                      <div class="label">
                        <span class="aisea-text-14-700-black label">{{
                          inputs.name.label
                        }}</span>
                        <span v-if="!isViewMode" class="validation-label"
                          >*</span
                        >
                      </div>
                      <span v-if="isViewMode" class="aisea-text-14-400-black">{{
                        inputs.name.value
                      }}</span>
                      <vs-input
                        v-else
                        class="name-input"
                        color="#2D9CDB"
                        v-model="inputs.name.value"
                      ></vs-input>
                    </div>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                    vs-w="12"
                  >
                    <div class="string-input">
                      <span class="aisea-text-14-700-black label">{{
                        inputs.personInCharge.label
                      }}</span>
                      <span v-if="isViewMode" class="aisea-text-14-400-black">{{
                        inputs.personInCharge.value
                      }}</span>
                      <vs-input
                        v-else
                        class="person_in_charge-input"
                        color="#2D9CDB"
                        v-model="inputs.personInCharge.value"
                      ></vs-input>
                    </div>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="center"
                    :vs-w="getDeviceInfo().deviceType === 'iPhone' && getDeviceInfo().deviceOrientation === 'landscape' ? 7 : 12"
                  >
                    <div class="string-input">
                      <span class="aisea-text-14-700-black label">{{
                        inputs.tel.label
                      }}</span>
                      <span v-if="isViewMode" class="aisea-text-14-400-black">{{
                        inputs.tel.value
                      }}</span>
                      <vs-input
                        v-else
                        class="tel-input"
                        color="#2D9CDB"
                        v-model="inputs.tel.value"
                      ></vs-input>
                    </div>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    :vs-justify="getDeviceInfo().deviceType === 'iPhone' && getDeviceInfo().deviceOrientation === 'landscape' ? 'flex-end' : 'flex-start'"
                    vs-align="center"
                    :vs-w="getDeviceInfo().deviceType === 'iPhone' && getDeviceInfo().deviceOrientation === 'landscape' ? 5 : 12"
                  >
                    <template v-if="isViewMode">
                      <vs-button
                        class="insert-button aisea-text-14-400-white"
                        color="#BDBDBD"
                        @click="popupActive = true"
                        >削除</vs-button
                      >
                      <vs-button
                        class="aisea-text-14-400-white"
                        color="#2D9CDB"
                        @click="isEditing = true"
                        >編集</vs-button
                      >
                    </template>
                    <template v-else-if="isEditMode">
                      <vs-button
                        class="aisea-text-14-400-white"
                        color="#BDBDBD"
                        @click="cancelEdit"
                        >キャンセル</vs-button
                      >
                      <vs-button
                        :disabled="!activeInsertButton"
                        class="insert-button aisea-text-14-400-white"
                        color="#2D9CDB"
                        @click="updateData"
                        >保存</vs-button
                      >
                    </template>
                    <template v-else>
                      <vs-button
                        class="aisea-text-14-400-white"
                        color="#BDBDBD"
                        :to="{
                          name: 'addon-eco-ship-container-customer-master',
                        }"
                        >キャンセル</vs-button
                      >
                      <vs-button
                        :disabled="!activeInsertButton"
                        class="insert-button aisea-text-14-400-white"
                        color="#2D9CDB"
                        @click="insertData"
                        >登録</vs-button
                      >
                    </template>
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-popup
        class="basic-master-popup"
        title="顧客情報の削除"
        :active.sync="popupActive"
      >
        <p>「{{ inputs.name.value }}」を削除してよろしいですか？</p>
        <div class="button-area">
          <vs-button
            class="popup-button"
            color="#BDBDBD"
            @click="popupActive = false"
            >キャンセル</vs-button
          >
          <vs-button class="popup-button" color="#2D9CDB" @click="callDelete"
            >削除</vs-button
          >
        </div>
      </vs-popup>
      <error-dialog ref="errorDialog"></error-dialog>
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../components/ErrorDialog";
import { DeviceInfoMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("ecoShip");

export default {
  components: {
    ErrorDialog,
  },
  mixins: [DeviceInfoMixin],
  props: {
    mode: { type: String, required: true }, // "view" or "insert"
  },
  data() {
    return {
      isEditing: false,
      inputs: {
        name: {
          label: "顧客企業名",
          value: null,
          originalValue: null,
        },
        personInCharge: {
          label: "担当者",
          value: null,
          originalValue: null,
        },
        tel: {
          label: "電話番号",
          value: null,
          originalValue: null,
        },
      },
      version: null,
      inputValues: [],
      popupActive: false,
    };
  },
  async created() {
    if (this.isViewMode) {
      this.$vs.loading();
      let payload = {
        id: this.$route.params.itemId,
      };

      let res = await this.fetchContainerCustomerDetail(payload);
      let containerCustomer = res;

      this.inputs.name.value = containerCustomer.name;
      this.inputs.personInCharge.value = containerCustomer.person_in_charge;
      this.inputs.tel.value = containerCustomer.tel;

      Object.keys(this.inputs).forEach((key) => {
        this.inputs[key].originalValue = this.inputs[key].value;
      });
    }
    this.$vs.loading.close();
  },
  computed: {
    isViewMode() {
      return this.mode == "view" && !this.isEditing;
    },
    isEditMode() {
      return this.isEditing;
    },
    activeInsertButton() {
      let regex = /.+/;
      return this.inputs.name.value
        ? this.inputs.name.value.match(regex)
        : false;
    },
  },
  methods: {
    ...mapActions([
      "insertContainerCustomer",
      "fetchContainerCustomerDetail",
      "updateContainerCustomer",
      "deleteContainerCustomer",
    ]),
    cancelEdit() {
      this.isEditing = false;
      Object.keys(this.inputs).forEach((key) => {
        this.inputs[key].value = this.inputs[key].originalValue;
      });
    },
    backToMaster() {
      this.$router.push({
        name: "addon-eco-ship-container-customer-master",
      });
    },
    async callDelete() {
      this.popupActive = false;
      let payload = {
        id: this.$route.params.itemId,
      };
      try {
        this.$vs.loading();
        await this.deleteContainerCustomer(payload);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "データを削除しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.$router.push({
          name: "addon-eco-ship-container-customer-master",
        });
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "データを削除できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async updateData() {
      let name = this.inputs.name.value;
      let person_in_charge = this.inputs.personInCharge.value;
      let tel = this.inputs.tel.value;

      let payload = {
        id: this.$route.params.itemId,
        body: {
          name: name,
          person_in_charge: person_in_charge,
          tel: tel,
        },
      };
      try {
        this.$vs.loading();
        await this.updateContainerCustomer(payload);
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.$router.push({
          name: "addon-eco-ship-container-customer-master",
        });
      } catch (error) {
        if (error.code == "422") {
          let validationErrors = error.data.map((element) => {
            let label = this.inputs[element.target].label;
            let message = element.message;
            return {
              label: label,
              message: message,
            };
          });
          this.$refs.errorDialog.open("エラー", null, validationErrors);
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null);
        }
      }
      this.$vs.loading.close();
    },
    async insertData() {
      let name = this.inputs.name.value;
      let person_in_charge = this.inputs.personInCharge.value;
      let tel = this.inputs.tel.value;

      let payload = {
        id: this.$route.params.itemId,
        body: {
          name: name,
          person_in_charge: person_in_charge,
          tel: tel,
        },
      };
      try {
        this.$vs.loading();
        await this.insertContainerCustomer(payload);
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.$router.push({
          name: "addon-eco-ship-container-customer-master",
        });
      } catch (error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map((element) => {
            let label = this.inputs[element.target].label;
            let message = element.message;
            return {
              label: label,
              message: message,
            };
          });
          this.$refs.errorDialog.open("エラー", null, validationErrors);
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null);
        }
      }
      this.$vs.loading.close();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#container-customer-form {
  .vs-con-textarea {
    margin: 0px;
  }
  .vx-card {
    // min-width: 1100px;
    margin: 5px;
  }
  .insert-data-container {
    display: flex;
    justify-content: space-between;
  }
  .title-area {
    display: flex;
    margin-bottom: 1rem;
  }
  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    cursor: pointer;
  }
  .input-area {
    width: 100%;
  }
  .input-group {
    width: 100%;
    display: flex;
  }
  .input-column {
    width: 500px;
  }
  .right-column {
    margin-left: 60px;
  }
  .small-input-row {
    display: flex;
    justify-content: space-between;
  }
  .required-note-input {
    flex-grow: 1;
  }
  .input-row {
    margin: 20px 0px;
  }
  .string-input {
    height: 42px;
    display: flex;
    align-items: center;
  }
  .text-are-input {
    display: flex;
  }
  .tag-area {
    line-height: 1;
  }
  .read-only-tag {
    margin-bottom: 0px;
  }
  .multiselect__tag-icon:hover {
    background: #666;
  }
  .tel-input,
  .name-input,
  .person_in_charge-input {
    width: 100%;
  }
  .number-input {
    width: 40px;
  }
  .label {
    width: 130px;
  }
  .validation-label {
    color: red;
    margin-left: 4px;
  }
  .insert-button {
    margin-left: 10px;
  }
  .vs-button {
    margin: 0.8rem 1.2rem 0 0.0rem;
  }
}
</style>
